import React from "react";
import ReactDOM from "react-dom/client";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { ampli } from "./ampli";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  isAppAuthenticated,
  isLoggedIn,
  logOut,
  UserContext,
} from "./setup/context/authContext";
import * as ar from "./translations/ar.json";

// analytics

import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

ampli.load({
  environment:
    process.env.NODE_ENV === "development" ? "development" : "production",
});

i18n.use(initReactI18next).init({
  resources: {
    ar: {
      translation: ar,
    },
  },
});

i18n.changeLanguage("ar");

root.render(
  <React.StrictMode>
    <UserContext.Provider
      value={{
        isLoggedIn: isLoggedIn,
        logOut: logOut,
        isAppAuthenticated: isAppAuthenticated,
      }}>
      <App />
    </UserContext.Provider>
  </React.StrictMode>
);

reportWebVitals();
